import candidateService from '@/api/candidate.service'

const actions = {
  fetchCandidateDetails(context) {
    return new Promise((resolve, reject) => {
      candidateService
        .fetchCandidateDetails(context)
        .then(response => {
          console.log('response: ', response)
          context.commit('candidateDetails', response)
          context.commit('closeupDetails', response)
          context.commit('isCloseup', response[0] && response[0].closeUP)
          context.commit('closeupCount', response)
          if (response[0].corporateInfo.length) {
            context.dispatch('adminPanelModule/setCICompanyInfo', response[0].corporateInfo[0], {
              root: true,
            })
          } else {
            context.dispatch('adminPanelModule/setCICompanyInfo', null, { root: true })
          }
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  fetchCandidateProfileById(context, payload) {
    // This is a recruiter only api.
    return new Promise((resolve, reject) => {
      candidateService
        .fetchCandidateProfileById(context, payload)
        .then(response => {
          console.log(response)
          context.commit('candidateDossierDetails', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  fetchCandidateDetailsById(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .fetchCandidateDetailsById(context, payload)
        .then(response => {
          console.log('By ID RESPONSE: ', response)
          context.commit('candidateDetails', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  fetchCandidateDetailsByIdPrivate(context, payload) {
    return candidateService.fetchCandidateDetailsByIdPrivate(context, payload)
  },
  createProfile(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .createProfile(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  updateProfileByRecruiter(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .updateProfileByRecruiter(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  updateProfile(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .updateProfile(context, payload)
        .then(response => {
          const candidateInfo = [
            {
              firstName: response.userFirstName,
              lastName: response.userLastName,
              email: response.userEmail,
              canPic: {
                cProfilePic: response.cProfilePic,
              },
            //   closeUpEnabled: response.corporateInfo.companyCloseUp
            },
          ]
          context.commit('candidateSettingsModule/candidateInfo', candidateInfo, {
            root: true,
          })
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  addExperience(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .addExperience(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  updateExperience(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .updateExperience(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  deleteExperience(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .deleteExperience(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  addEducation(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .addEducation(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  updateEducation(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .updateEducation(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  deleteEducation(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .deleteEducation(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  addLanguage(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .addLanguage(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  updateLanguage(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .updateLanguage(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  deleteLanguage(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .deleteLanguage(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  addSkill(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .addSkill(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  deleteSkill(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .deleteSkill(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  deleteProfilePic(context) {
    return new Promise((resolve, reject) => {
      candidateService
        .deleteProfilePic(context)
        .then(response => {
          context.commit('candidateSettingsModule/candidateInfo', [{}], {
            root: true,
          })
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  deleteProfileVid(context) {
    return new Promise((resolve, reject) => {
      candidateService
        .deleteProfileVid(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  createDoc(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .createDoc(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  updateDoc(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .updateDoc(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  deleteDoc(context, payload) {
    return new Promise((resolve, reject) => {
      candidateService
        .deleteDoc(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
}

export default actions
